/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/ThemeManager',[], function () {
    "use strict";

    var ThemeManager = {
        CurrentTheme: "classic"
    };

    return ThemeManager;

});
